if ($('.rtc-winners').length) {

    $('.js-rtc-winners-load-more').on('click', function () {
        $('.rtc-winners li.d-none').each(function (idx, elm) {

            if (idx < 16) {
                $(elm).removeClass('d-none');
            }

        });

        if (!$('.rtc-winners li.d-none').length) {
            $('.js-rtc-winners-load-more').hide('fast');
        }
    });

    $('#filter-date, #filter-state').on('change', function () {

        $('.js-no-results').addClass('d-none');
        $('.js-reset').removeClass('d-none');

        $('.js-rtc-winners-load-more').hide('fast');


        let classNames = [];

        if (!$('#filter-date').val().length && !$('#filter-state').val().length) {
            resetWinnerFilters();
            return;
        }

        if ($('#filter-date').val().length) {
            classNames.push('.' + $('#filter-date').val());
        }
        if ($('#filter-state').val().length) {
            classNames.push('.' + $('#filter-state').val());
        }


        $('.rtc-winners li').each(function (idx, elm) {
            if ($(elm).is(classNames.join(''))) {
                $(elm).removeClass('d-none');
            } else {
                $(elm).addClass('d-none');
            }
        });

        if ($('.rtc-winners li:not(.d-none)').length == 0) {
            $('.js-no-results').hide().removeClass('d-none').show('fast');
        }


    });

    $('.js-reset-btn').on('click', function () {
        $('#filter-date').val('');
        $('#filter-state').val('');
        $('.js-no-results').addClass('d-none');

        resetWinnerFilters();
        return;
    });

    resetWinnerFilters = function () {
        $('.rtc-winners li').each(function (idx, elm) {
            if (idx < 16) {
                $(elm).removeClass('d-none');
            } else {
                $(elm).addClass('d-none');
            }
        });

        $('.js-rtc-winners-load-more').show('fast');

        $('.js-reset').addClass('d-none');

        return;
    }

}